<template>
  <div class="modal" id="restoreModal" tabindex="-1" aria-labelledby="restoreModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="restoreModalLabel">復元確認</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="close"></button>
        </div>
        <div class="modal-body">
          本当に復元しますか？
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="close">キャンセル</button>
          <button type="button" class="btn btn-warning" @click="confirmRestore" data-bs-dismiss="modal">復元</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['paramsId'],
  emits: ['confirmRestore', 'close'],
  methods: {
    confirmRestore() {
      this.$emit('confirmRestore', this.paramsId);
    },
    close() {
      this.$emit('close');
    }
  }
}
</script>
